export function getOptimalFloatingBadgePosition(
  widgetPosition: string
): "left" | "right" | "top" | "bottom" {
  switch (widgetPosition) {
    case "bottom-right":
    case "top-right":
      return "left";
    case "bottom-left":
    case "top-left":
      return "right";
    default:
      return "left";
  }
}

export function getOptimalNotificationBadgePosition(widgetPosition: string): string {
  switch (widgetPosition) {
    case "bottom-right":
      return "top-left";
    case "bottom-left":
      return "top-right";
    case "top-right":
      return "bottom-left";
    case "top-left":
      return "bottom-right";
    default:
      return "top-right";
  }
}

